<template>
    <div class="usecoupon">
        <div class="defautwrap">
            <div class="topnav">
                <img src="../assets/img/fh-icon@2x.png" alt="" @click="backnative">
                <span>
                使用代金券
              </span>
            </div>
            <div class="content">
                <div class="nonum" v-if='list.length==0'>
                  <img src="../assets/img/nonum@2x.png" alt="">
                  <p>暂无数据</p>
                </div>
                <div v-for="item in list" :key="item.id" class="content_item_wrap">
                <div class="content_item">
                    <div class="money">
                    <p class="amount"><span>￥</span>{{item.resetAmount|money}}</p>
                    <p class="ruleamount">消费满{{item.ruleAmount|money}}元可用</p>
                    </div>
                    <div class="contenttext">
                    <p class="titlefont">{{item.couponName}}</p>
                    <!-- <p class="timecontent timelineheight">消费满{{item.ruleAmount|money}}元可用</p> -->
                    <!-- <p class="timecontent timelineheight">有效期：</br><span>{{item.startTime|formatDate}}-{{item.endTime|formatDate}}</span></p> -->
                    </div>
                <div class="lqbtn giftbtn"  @click="select(item)">
                    <!-- {{active==1?'领取':'已领取'}} -->
                    <img src="../assets/img/weixuanzhong@2x.png" alt="" v-if='couponId==item.couponId'>
                    <img src="../assets/img/xuanzhong@2x.png" alt="" v-else>
                </div>
                <div>
                </div>
                </div>
                </div>
            </div>
            <div class="usebtn">
              <div class="btn" @click="usecoupon">
                 不使用代金券
              </div>
            </div>
            </div>
    </div>
</template>
<script>
import {getvouchersed} from '@/api/vouchers'
export default {
    data(){
        return{
            form:{
            userId:'',
            productId:'',
            channelId:'',
            osType:''
            },
            list:[],
            selectitem:{},
            couponId:''
        }
    },
    filters:{
      money(val){
       return val/100
     },
     formatDate(data) {
        if(!data){return '-'}
        //时间戳是整数，否则要parseInt转换
        var time = new Date(data*1000); // 需要使用Date格式进行日期转化，若是时间戳、字符串时间，需要通过new Date(..)转化
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        // return y+'-'+isZero(m)+'-'+isZero(d)+' '+isZero(h)+':'+isZero(mm)+':'+isZero(s);
        return y+'.'+isZero(m)+'.'+isZero(d);
        function isZero(m){
        return m<10?'0'+m:m
        }
      }
    },
    methods:{
      backnative(bol){
        if(bol){
          const item = this.selectitem
          if(this.form.osType == 1){
            try{
              window.SDK.callbackUsecoupon(item.resetAmount,item.id,item.couponUseType);
            }catch(error){
              console.log(error)
            }
          }else if(this.form.osType == 2){
            try{
              const jsonstr = JSON.stringify(item)
              window.webkit.messageHandlers.callbackUsecoupon.postMessage(jsonstr);
            }catch(error){
              console.log(error)
            }
          }
        }else{
          if(this.form.osType == 1){
          try{
            window.SDK.backys();
          }catch(error){
            console.log(error)
          }
          }else if(this.form.osType == 2){
            try{
              window.webkit.messageHandlers.backys.postMessage();
            }catch(error){
              console.log(error)
            }
          }
        }
      },
      usecoupon(){
        this.selectitem = null
        if(this.form.osType == 1){
          try{
            window.SDK.backys();
          }catch(error){
            console.log(error)
          }
          }else if(this.form.osType == 2){
            try{
              window.webkit.messageHandlers.backys.postMessage('返回');
            }catch(error){
              console.log(error)
            }
          }
        // const item = this.selectitem
        // console.log(item)
        // if(!item.select){
        //   this.$Message.show('没有使用优惠券')
        //   return
        // }
      },
      select(item){
        // item.select = true
        if(this.money<item.ruleAmount){
          this.$Message.show('不满足使用条件')
          return
        }
        // if(item.select){
        //   this.selectitem = null
        //   item.select = null
        // }else{
          this.selectitem.select = null
          this.$set(item,'select',true)
        // }
        this.selectitem = item
        setTimeout(() => {
          this.backnative(true)
        }, 100);
      }
    },
    created(){
        if(this.$route.query.osType){
            this.form.osType = this.$route.query.osType
            this.form.channelId = this.$route.query.channelId
            this.form.productId = this.$route.query.productId
            this.form.userId = this.$route.query.userId
            this.money = this.$route.query.Money
        }
        this.couponId = this.$route.query.couponId
        getvouchersed(this.form).then(res=>{
          if(res.data.code == 200){
              this.list = res.data.data
          }
        })
    }
}
</script>
<style lang="less" scoped>
    .usecoupon{
        font-size: 0.7rem;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        .defautwrap{
        width: 100%;
        height: 100%;
        background: #F7F8F9;
        // padding: 0.75rem 1.25rem 0 1.25rem;
        .topnav{
            width: 100%;
            height: 2.25rem;
            background:#fff;
            text-align: center;
            line-height: 2.25rem;
            font-size:0.8rem;
            font-family:PingFang SC;
            color:rgba(17,17,17,1);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 100;
            img{
              height: 0.75rem;
              display: block;
              position: absolute;
              left: 0.75rem;
              top: 0;
              bottom: 0;
              margin: auto;
            }
        }

        // .topnav::before{
        //   width: 0.45rem;
        //   height: 0.75rem;
        //   content:'';
        //   display: block;
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   bottom: 0;
        //   margin: auto;
        //   background: url(../assets/img/icon.png) no-repeat left center;
        //   background-size:  0.45rem 0.75rem;
        // }
        .QQnum{
            width:92%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            min-height: 2.5rem;
            background: #fff;
            border-radius: 0.6rem;
            box-shadow:0rem 1px 0rem 0rem rgba(229,229,229,1);
            margin: 0 auto;
            padding: 0.48rem;
            div{
            img{
                height: 0.63rem;
                vertical-align: middle;
            }
            }
            &.martop{
            margin-top: 0.5rem;
            }
        }
        .kefumess{
            width: 92%;
            background: #fff;
            border-radius: 0.6rem;
            box-shadow:0rem 1px 0rem 0rem rgba(229,229,229,1);
            margin: 0 auto;
            padding: 0.48rem;
            display: flex;
            align-items: center;
            img{
            width: 1.7rem;
            height: 1.7rem;
            margin-left: 0;
            margin-right: 0.78rem;
            vertical-align: middle;
            }
            &.martop{
            margin-top: 0.5rem;
            }
        }
        }
        .content{
        width: 100%;
        height: 100%;
        background: rgb(247,248,249);
        padding:2.25rem 0.5rem 3rem;
        overflow-y: auto;
        position: relative;
        .content_item_wrap{
        background: #fff;
        .content_item{
        width: 100%;
        min-height: 3.75rem;
        border-radius: 0.4rem;
        overflow: hidden;
        margin-top: 0.5rem;
        padding: 0.75rem 0.53rem;
        // padding-bottom: 0;
        display: flex;
        justify-content: space-between;
        .contenttext{
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .timelineheight{
            height: 0.75rem;
            line-height: 0.75rem;
            margin-top: 0.25rem;
          }
        }
        .lqbtn{
          width:2.5rem;
          margin-left: 1.13rem;
          text-align: center;
          line-height: 1.15rem;
          align-self: center;
          flex-shrink: 0;
          img{
            width: 0.92rem;
            // height: 0.92rem;
          }
          &.userd{
            background: #C2C2C2;
            color: #fff;
          }
        }
        .titlefont{
          height: 0.75rem;
          line-height: 0.75rem;
          word-spacing: normal;
          overflow: hidden;
        }
        .giftcontent{
          display: flex;
          align-items: center;
          line-height: 0.725rem;
          flex-wrap: wrap;
          flex: 1;
          margin-top: 0.35rem;
        }
        .money{
          color: #F1B82E;
          font-weight:bold;
          font-size: 1rem;
          // display: flex;
          // align-items: center;
          text-align: center;
          border-right: 1px solid #F4F4F4;
          margin-right: 0.48rem;
          width: 4.9rem;
          .amount{
            font-size: 0.9rem;
            span{
            font-size: 0.6rem;
            }
          }
          .ruleamount{
            margin-top: 0.55rem;
            font-size: 0.45rem;
          }
        }
        
        // money
      }
      .outssice{
        width: 100%;
        padding: 0 0.75rem;
        .timecontent{
          width: 100%;
          padding-bottom: 0.55rem;
          border-bottom: 1px dashed #E19839;
        }
        .copynum{
          width: 100%;
          height: 1.58rem;
          line-height: 1.58rem;
        }
      }
    }
      }
      .usebtn{
        width: 100%;
        height: 2.45rem;
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        .btn{
          width: 12.45rem;
          height: 1.75rem;
          line-height: 1.75rem;
          text-align: center;
          background: #F5CB3F;
          border-radius:14px;
          margin:0.35rem auto;
          color: #fff;
        }
      }
    }
</style>